import BestSellingAuthor from './BestSellingAuthor'

export default class Publisher extends BestSellingAuthor {
  maxRunningArcs = -1
  canFreeTypePenNames = true
  canChooseBrandedDefaultReviewDisclaimer = true
  canHaveTeamFollowers = true
}
